import { colorSchemeDark, themeQuartz } from "ag-grid-enterprise";

export const fileTableTheme = themeQuartz.withPart(colorSchemeDark).withParams({
    accentColor: "#6B7280",
    backgroundColor: "#1E293B",
    borderColor: "#334155",
    browserColorScheme: "dark",
    fontFamily: {
        googleFont: "Inter",
    },
    foregroundColor: "#FFFFFF",
    headerFontSize: 14,
    headerVerticalPaddingScale: 1,

    rowHoverColor: "#334155",
    rowBorder: {
        color: "#0f172a",
    },
    headerColumnResizeHandleColor: "#475569",
    rowHeight: 48,
});
